import { default as default2 } from "./illustrations/IllustrationConstructionDark";
import { default as default3 } from "./illustrations/IllustrationConstruction";
import { default as default4 } from "./illustrations/IllustrationFailureDark";
import { default as default5 } from "./illustrations/IllustrationFailure";
import { default as default6 } from "./illustrations/IllustrationIdleDark";
import { default as default7 } from "./illustrations/IllustrationIdle";
import { default as default8 } from "./illustrations/IllustrationNoAccessDark";
import { default as default9 } from "./illustrations/IllustrationNoAccess";
import { default as default10 } from "./illustrations/IllustrationNoContentDark";
import { default as default11 } from "./illustrations/IllustrationNoContent";
import { default as default12 } from "./illustrations/IllustrationNoResultDark";
import { default as default13 } from "./illustrations/IllustrationNoResult";
import { default as default14 } from "./illustrations/IllustrationNotFoundDark";
import { default as default15 } from "./illustrations/IllustrationNotFound";
import { default as default16 } from "./illustrations/IllustrationSuccessDark";
import { default as default17 } from "./illustrations/IllustrationSuccess";
export {
  default3 as IllustrationConstruction,
  default2 as IllustrationConstructionDark,
  default5 as IllustrationFailure,
  default4 as IllustrationFailureDark,
  default7 as IllustrationIdle,
  default6 as IllustrationIdleDark,
  default9 as IllustrationNoAccess,
  default8 as IllustrationNoAccessDark,
  default11 as IllustrationNoContent,
  default10 as IllustrationNoContentDark,
  default13 as IllustrationNoResult,
  default12 as IllustrationNoResultDark,
  default15 as IllustrationNotFound,
  default14 as IllustrationNotFoundDark,
  default17 as IllustrationSuccess,
  default16 as IllustrationSuccessDark
};
